import * as React from "react";
import classNames from "classnames";

import {IIcon} from "../IIcon";
import {SvgIcon} from "./SvgIcon";

export const BellIcon = (props: IIcon) => {
    const {fillColor, size, wrapperColor, wrapperSize} = props;
    const className = classNames(props.className);

    return (
        <SvgIcon size={size || "1"} className={className} fillColor={fillColor} wrapperColor={wrapperColor} wrapperSize={wrapperSize}>
            <path d="M5,9.91a1,1,0,0,0,1-1H4A1,1,0,0,0,5,9.91Zm3-3V4.37A3.06,3.06,0,0,0,5.76,1.19V.84a.76.76,0,0,0-1.52,0v.35A3.06,3.06,0,0,0,2,4.37V6.89l-1,1v.5H9V7.9Zm-1,.5H3v-3A2.07,2.07,0,0,1,5,2.1,2.07,2.07,0,0,1,7,4.37Z" />
        </SvgIcon>
    );
};
